export const options = [
  {
    label: "about.title",
    value: "about",
    children: [
      {
        label: "about.info",
        value: "info",
      },
      // {
      //   label: "about.management",
      //   value: "management",
      // },
      {
        label: "about.structure",
        value: "structure",
      },
      // {
      //   label: "about.awards",
      //   value: "awards",
      // },
      // {
      //   label: "about.legal",
      //   value: "legal",
      // },
    ],
  },
  {
    label: "about.investors",
    value: "investors",
    children: [
      {
        label: "investors.capital",
        value: "capital",
      },
      // {
      //   label: "investors.business-plan",
      //   value: "business-plan",
      // },
      // {
      //   label: "investors.internal-documents",
      //   value: "internal-documents",
      // },
      // {
      //   label: "investors.dividends",
      //   value: "dividends",
      // },
      // {
      //   label: "investors.own-shares",
      //   value: "own-shares",
      // },
      // {
      //   label: "investors.management-organisations",
      //   value: "management-organisations",
      // },
      // {
      //   label: "investors.reports",
      //   value: "reports",
      // },
      // {
      //   label: "investors.diclosure",
      //   value: "Disclosure",
      // },
    ],
  },
  {
    label: "vacancies",
    value: "vacancies",
  },
  {
    label: "purchases",
    value: "purchases",
  },
  {
    label: "about.standard_contract.menu",
    value: "standard-contract",
  },
];
